import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Hero = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
        }
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.2
            }
        }
    };

    return (
        <section className="hero hero-centered">
            <div className="hero-background-blur"></div>
            <div className="hero-yellow-lines">
                <div className="yellow-line yellow-line-1"></div>
                <div className="yellow-line yellow-line-2"></div>
                <div className="yellow-line yellow-line-3"></div>
            </div>

            <div className="hero-content-centered">
                <motion.div
                    className="hero-text-centered"
                    initial="hidden"
                    animate="visible"
                    variants={staggerContainer}
                >
                    <motion.div className="hero-badge" variants={fadeInUp}>
                        <span>🎄 Holiday Season Crash Course Available</span>
                    </motion.div>
                    <motion.h1 variants={fadeInUp}>
                        Expert British Tutoring for Students in the <span className="highlight-yellow">Middle East</span>
                    </motion.h1>
                    <motion.p className="hero-description" variants={fadeInUp}>
                        Unlock Your Potential with World-Class UK Tutors. Tailored Support for GCSEs, A-Levels, and University Admissions.
                    </motion.p>

                    <motion.div className="hero-trust-markers" variants={fadeInUp}>
                        <div className="trust-marker-item">
                            <span>✓ British Curriculum Experts</span>
                        </div>
                        <div className="trust-marker-item">
                            <span>✓ Proven Results</span>
                        </div>
                        <div className="trust-marker-item">
                            <span>✓ 4.8/5 Student Rating</span>
                        </div>
                    </motion.div>

                    <motion.div className="hero-cta-group" variants={fadeInUp}>
                        <a href="#contact" className="button-primary-yellow">
                            Contact Us <FaArrowRight />
                        </a>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;

